import ResetPasswordForm, { ResetPasswordFormProps } from './ResetPasswordForm';

export type { ResetPasswordFormProps };
export default ResetPasswordForm;
